import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../../UI/Modal/Modal'
import cl from './UserAdd.module.css'
import Plus from "../../../../../assets/Icon/Plus";
import Mobile from "../../../../../assets/Icon/Mobile";
import At from "../../../../../assets/Icon/At";
import Id from "../../../../../assets/Icon/Id";
import Lock from "../../../../../assets/Icon/Lock";
import User from "../../../../../assets/Icon/User";
import { AppContext } from '../../../../../providers/appProvider';
import { selectStyle } from './selectStyle';
import Select from "react-select";
import Form from '../../../../../assets/Style/Form.module.css'

const AddUserModal = ({ newUserService, userService, defaultClient }) => {
    const userResetData = {
        id: 0,
        firstname: defaultClient.firstname,
        lastname:  defaultClient.lastname,
        personal:  defaultClient.personal,
        email:  defaultClient.email,
        password: defaultClient.password,
        mobile: defaultClient.mobile, 
        role_id: 0,
        salary: 1500,
        bonus_percent: 5, 
        bonus_max_percent: 50, 
        saler_id: 0,
    }




    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };

    const [newUser, setNewUser] = useState(userResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const { appState, app } = useContext(AppContext);
    const salers = appState.salers.map((saler) => ({ value: saler.id, label: `${saler.firstname} ${saler.lastname}` }));

    const roles = appState.roles.map((role) => ({ value: role.id, label: role.description }));

    const findRoleIdByName = (name) => {
        const role = appState.roles.find(role => role.name === name);
        return role ? role.id : 0;
    }

    const adminRoleId = findRoleIdByName("administrator");
    const clientRoleId = findRoleIdByName("client");
    const salerRoleId = findRoleIdByName("saler");
    const dealerRoleId = findRoleIdByName("dealer");


    const validateUser = (user) => {
        const messages = {};

        if (user.firstname.length < 2) {
            messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
        }

        if (user.lastname.length < 2) {
            messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
        }


        if (user.personal.length != 11) {
            messages.personal = { message: 'საჭროა 11 სიმბოლო', isValid: false };
        }

        if (user.mobile.length != 9) {
            messages.mobile = { message: 'საჭროა 9 სიმბოლო', isValid: false };
        }

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!user.email || user.email.length === 0 || !emailRegex.test(user.email)) {
            messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
        }

        if (user.password.length < 6) {
            messages.password = { message: 'საჭროა 6 ან მეტი სიმბოლო', isValid: false };
        }

        if (user.role_id < 1) {
            messages.role_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (user.role_id === dealerRoleId) {
            if (user.saler_id < 1) {
                messages.saler_id = { message: 'სავალდებულოა', isValid: false };
            }
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validateUser(newUser)

    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateUser(newUser)
        }
    }, [newUser, isFirstValidated]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const saveHandle = () => {

        const isValidate = validateUser(newUser)

        if (isValidate === true) {
            var userForAdd = {...newUser}

            if (dealerRoleId !== newUser.role_id) {
                delete userForAdd.saler_id
            }

            if ( (adminRoleId !== newUser.role_id) && (salerRoleId !== newUser.role_id)  ){
                   userForAdd = {
                    ...userForAdd,
                    salary: 0,
                    bonus_percent: 0,
                    bonus_max_percent: 0
                };
            }

            userService.add(userForAdd) 
            .then(response => {
                newUserService.remove(defaultClient.id)
                alert('მომხმარებელი წარმატებით დაემატა');
                setIsModalOpen(false)
           })
           .catch(error => {
               console.error(error);
               alert('შეცდომა დამეტებისას'); 
           }); 
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
 
    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewUser(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)
        setNewUser(userResetData)
    }

    const setIsAdmin = (isAdmin) => {
        setNewUser(prevClient => ({
            ...prevClient,
            is_admin: isAdmin
        }));
    }

    return (
        <div>

            <span onClick={() => openAdd()} className={cl.AddBtn}> 
                 აქტივაცია
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Plus /></span> აქტივაცია
                    </h3>
                </div>

                <div className={cl.inp2col}>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.firstname ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="სახელი" name="firstname" value={newUser.firstname} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <User />
                            </div>
                        </div>
                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.lastname ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="გვარი" name="lastname" value={newUser.lastname} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <User />
                            </div>
                        </div>
                    </div>

                </div>

                <div className={cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS"
                            className={validates && validates.personal ? cl.input + ' ' + cl.errorInput : cl.input}
                            placeholder="პირადი ნომერი" name="personal" value={newUser.personal} onChange={handleClientChange} autoComplete="off" />
                        <div className={cl.crmIcon}>
                            <Id />
                        </div>
                    </div>
                    {validates && validates.personal &&
                        <div className={cl.errorMsg} >{validates.personal.message}</div>}
                </div>


                <div className={cl.inp2col} style={{ marginBottom: 0 }}>
                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.mobile ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="მობილური" name="mobile" value={newUser.mobile} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}><Mobile /></div>
                        </div>
                        {validates && validates.mobile &&
                            <div className={cl.errorMsg} >{validates.mobile.message}</div>}

                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.email ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="ელ-ფოსტა" name="email" value={newUser.email} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}><At /></div>
                        </div>
                        {validates && validates.email &&
                            <div className={cl.errorMsg} >{validates.email.message}</div>}

                    </div>

                </div>




                <div className={cl.groupInput}>
                    <Select
                        styles={validates && validates.role_id ? { ...selectStyle, ...stylesError } : selectStyle}
                        options={roles}
                        placeholder="აირჩიე როლი"
                        value={roles.find(option => option.value === newUser.role_id)}
                        onChange={(selectedOption) => {
                            setNewUser(prevState => ({
                                ...prevState,
                                role_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                </div>





             


                {
                    (adminRoleId === newUser.role_id || salerRoleId === newUser.role_id) &&
                    <>
                        <div className={cl.groupPrice}>
                            <label className={cl.leftLabel}>ხელფასი</label>
                            <div className={cl.rightInput}>
                                <div className={Form.priceInput}>
                                    <div className={Form.priceCurrency}>
                                        GEL
                                    </div>
                                    <input type="text" name="solary" className={Form.input} value={newUser.salary} onChange={handleClientChange} min="0" />
                                    <div className={Form.hundred} >.00</div>
                                </div>
                            </div>
                        </div>

                        <div className={cl.groupPrice}>
                            <label className={cl.leftLabel}>ბონუსი</label>
                            <div className={cl.rightInput}>
                                <div className={Form.priceInput}>
                                    <div className={Form.priceCurrency}>
                                        %
                                    </div>
                                    <input type="text" name="bonus_percent" className={Form.input} value={newUser.bonus_percent} onChange={handleClientChange} min="0" />
                                    <div className={Form.hundred} >.00</div>
                                </div>
                            </div>
                        </div>

                        <div className={cl.groupPrice}>
                            <label className={cl.leftLabel}>მაქ. ბონუსი</label>
                            <div className={cl.rightInput}>
                                <div className={Form.priceInput}>
                                    <div className={Form.priceCurrency}>
                                        %
                                    </div>
                                    <input type="text" name="bonus_max_percent" className={Form.input} value={newUser.bonus_max_percent} onChange={handleClientChange} min="0" />
                                    <div className={Form.hundred} >.00</div>
                                </div>
                            </div>
                        </div>
                    </>
                }



                {dealerRoleId === newUser.role_id &&
                    <>
                        <div className={cl.groupInput}>
                            <Select
                                styles={validates && validates.saler_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                options={salers}
                                placeholder="აირჩიე სელერი"
                                value={salers.find(option => option.value === newUser.saler_id)}
                                onChange={(selectedOption) => {
                                    setNewUser(prevState => ({
                                        ...prevState,
                                        saler_id: selectedOption ? selectedOption.value : 0,
                                    }));
                                }}
                            />
                        </div>
                    </>
                }




                <span onClick={saveHandle} className={cl.btnPrimary}>აქტივაცია</span>
            </Modal>
        </div>
    );
};

export default AddUserModal;